// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__2-Ddx","active":"NavigationItem_active__2rAoj"};